// client/src/MessageInput.js
import React from 'react';

function MessageInput({ userInput, setUserInput, onSendMessage }) {

  const handleKeyDown = (e) => {
    // Check if Enter is pressed WITHOUT the Shift key
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
    // If Shift+Enter is pressed, the default behavior (new line) is allowed.
  };

  return (
    <div className="bg-white p-4">
      <form className="relative" onSubmit={onSendMessage}>
        <textarea
          // Updated placeholder text
          placeholder="Votre message ici... (Shift+Enter pour saut de ligne)"
          className="flex w-full min-w-0 flex-1 resize-none overflow-y-auto rounded-lg text-[#111418] focus:outline-0 focus:ring-2 focus:ring-blue-500 border-none bg-[#f0f2f4] placeholder:text-[#637588] px-4 py-3 text-base font-normal leading-normal min-h-[9rem] pr-28"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          onKeyDown={handleKeyDown}
          rows={3}
        />
        <button
          type="submit"
          className="absolute bottom-4 right-4 min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-4 bg-[#197fe5] text-white text-sm font-medium leading-normal disabled:bg-blue-300"
          // Disable the button if there is no text
          disabled={!userInput.trim()}
        >
          <span className="truncate">Send</span>
        </button>
      </form>
    </div>
  );
}

export default MessageInput;